import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { weekDaysLong, getWeekDayName } from '../../../../helpers/localization/localizationUtils';
import Box from '../../../elements/Box';
import { BoxProps } from '../../../elements/Box/Box';

export type WeekDayProps = BoxProps & {
  weekday: number;
  weekDayFormat?: 'long' | 'short' | 'min' | 'oneLetter' | null;
  fontSize?: string;
  textAlign?: string;
  padding?: string;
  border?: boolean;
  rounded?: string;
  style?: React.CSSProperties;
};

function WeekDay({ weekday, weekDayFormat = 'long', ...props }: WeekDayProps) {
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box
      className={`front10-date-selector-weekday ${className}`}
      {...props}
      style={style}
      aria-label={weekDaysLong(translate, localizationData)[weekday]}
      role="cell"
      display="table-cell"
    >
      {getWeekDayName(weekday, weekDayFormat, translate, localizationData)}
    </Box>
  );
}
WeekDay.defaultProps = {
  fontSize: '4',
  textAlign: 'center',
  padding: '1',
  border: true,
  rounded: '@theme:card.rounded'
};
export default WeekDay;
